import Vue from 'vue';
import Vuex from 'vuex';
import AuthStore from './modules/AuthStore';
import UserStore from './modules/UserStore';
import VoucherStore from './modules/VoucherStore';
import VoucherTypeStore from './modules/VoucherTypesStore';
import TicketStore from './modules/TicketStore';
import DebitNoteStore from './modules/DebitNoteStore';
import GusStore from './modules/GusStore';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    AuthStore,
    UserStore,
    VoucherStore,
    VoucherTypeStore,
    TicketStore,
    DebitNoteStore,
    GusStore,
  },
});
